import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
var useStyles = makeStyles({
    root: {
        flex: '1 0 auto',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
}, { name: 'SnDialogContentText' });
/**
 * ダイアログテキストコンテントコンポーネント。
 *
 * - DialogContentの中がテキストのみの場合に用いる。
 * - Typographyのラッパー。
 * - 文字サイズの共通化のためにvariantはpropsに用意しない。
 */
export var DialogContentText = function (props) {
    var classes = useStyles(props);
    // Material-UIのDialogContentTextと同様に、Typographyをラップする。
    return (React.createElement("div", { className: classNames(classes.root, props.className), style: props.style },
        React.createElement(Typography, { variant: "body1", align: "center" }, props.children)));
};
